module.exports = __webpack_public_path__ + "img/how-to-flow-l-03.1140f00b.svg";